import { render } from "./error.vue?vue&type=template&id=b5bf43b2&scoped=true"
import script from "./error.vue?vue&type=script&lang=js"
export * from "./error.vue?vue&type=script&lang=js"

import "./error.vue?vue&type=style&index=0&id=b5bf43b2&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5bf43b2"]])

export default __exports__